import { useCallback, useState } from 'react';
import produce from 'immer';

export const useProducedState = <T>(initialState: T) => {
    const [state, setState] = useState(initialState);

    const produceState = useCallback((producer: (draft: T) => T | void) => {
        const newState = produce(state, producer);
        setState(newState as T);
    }, [state]);

    return [state, produceState] as const;
};
